// Uppercase C in the ASCII table
export const CAPITAL_ASCII_LETTERS_START_INDEX = 67;
export const WEIGHTED_VALUES_ROW_NUMBER = 11;
